/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 简单文件上传返回对象
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oss.UploadFileReturnDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oss/fileReturn`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
